<div class="included-per-passenger">
    <h2 class="title-h2">{{ 'whatsIncludedSidebars.general.title.includedPerPassenger' | ibeadmin: 'sync' }}</h2>

    <div class="border included-per-passenger--item " *ngFor="let passenger of passengers; let i = index">
        <div class="grid no-padding">
            <div class="col-4 col-tp-4 col-p-12 no-padding">
                <p class="bold">{{ INDRA_printName(passenger) }}</p>
            </div>
            <div class="col-8 col-tp-8 col-p-12 included-per-passenger--label">
                <p class="" [innerHTML]="INDRA_printLabel(i)"></p>
            </div>
        </div>
    </div>

</div>